import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Field, FieldArray, ErrorMessage } from 'formik'
import Row from 'antd/es/row'
import Col from 'antd/es/col'
import Input from 'antd/es/input'
import Tag from 'antd/es/tag'
import Tooltip from 'antd/es/tooltip'
import Button from "antd/es/button";
import Select from 'antd/es/select'
import FieldLabel from '../../partials/fieldLabel.jsx'
import CustomInputComponent from '../../partials/formik/customInputComponent.jsx'
import InputAutoComplete from '../../partials/inputAutoComplete.jsx'
import { mockSpecialities } from './mockSpecialities.js'
import PhoneInputComponent from '../../partials/formik/PhoneInputComponent.jsx'

const { Option } = Select

const style = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '32px',
}

const styles = {
  tag: {
    ...style,
    marginBottom: '8px',
    textTransform: 'uppercase',
  },
  addSkill: {
    ...style,
    color: '#41AAE2',
    border: '1.5px solid #15A9E1',
    cursor: 'pointer',
    marginRight: '11px',
    marginLeft:'7px',
    height: "32px",
  },
}

function EditForm() {
  const [inputVisible, setInputVisible] = useState(false)

  function showInput() {
    setInputVisible(true)
  }

  return (
    <div className="profile-edit-form">
      <Row gutter={24}>
        <Col xs={24} sm={10}>
          <FieldLabel label="Full Name">
            <Field
              name="name"
              component={CustomInputComponent}
            />
          </FieldLabel>
        </Col>
        <Col xs={24} sm={10}>
          <FieldLabel label="Phone Number">
          <Field
          name="phone"
          placeholder="insert phone number here"
          component={PhoneInputComponent}
        />
          </FieldLabel>
        </Col>
      </Row>
      <div>
        <FieldArray
          name="specialities"
          render={({
            form: {
              values: { specialities, speciality },
              setFieldValue,
            },
            remove, push,
          }) => {
            function onChange(value) {
              setFieldValue('speciality.name', value)
            }

            function onInputConfirm() {
              if (speciality.name && specialities.indexOf(speciality) === -1) {
                push({ ...speciality })
              }

              setInputVisible(false)
              setFieldValue('speciality.name', '')
            }

            return (
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {
                  specialities && specialities.length > 0 && specialities.map(({ name }, index) => {
                    const isLongTag = name.length > 20

                    const tagElem = (
                      <Tag
                        style={styles.tag}
                        key={index}
                        closable
                        onClose={() => remove(index)}
                      >
                        {isLongTag ? `${name.slice(0, 20)}...` : name}
                      </Tag>
                    )

                    return isLongTag ? (
                      <Tooltip title={name} key={index}>
                        {tagElem}
                      </Tooltip>
                    ) : (
                      tagElem
                    )
                  })
                }
                {
                  inputVisible && (
                    <InputAutoComplete
                      rootStyle={{ width: 214, marginRight: '12px' }}
                      dataSource={mockSpecialities}
                      onChange={onChange}
                      onInputConfirm={onInputConfirm}
                    />
                  )
                }
                {
                  (
                      <Button icon="plus" onClick={showInput} style={styles.addSkill}>
                        Add Specialty
                      </Button>
                  )
                }
              </div>
            )
          }}
        />
      </div>
    </div>
  )
}

EditForm.propTypes = {
  onSubmit: PropTypes.func,
}

export default EditForm
